require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-ten-gift-ideas-for-developers.json") })
        }
      }, "path---blog-ten-gift-ideas-for-developers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-ten-gift-ideas-for-developers!./.cache/json/blog-ten-gift-ideas-for-developers.json
// module id = 1077
// module chunks = 231608221292675